import React from 'react';
import { Panel, Button } from 'react-bootstrap';
import exact from 'prop-types-exact';
import PropTypes from 'prop-types';


import ReactTable from 'react-table';
import moment from 'moment-timezone';

import './style.css';
import {
  defaultTableFiltering,
  severityOfHours,
  openInNewTab,
} from '../../utils';

import { getUserTimesheetLink } from '../../features/timesheetNavigator/links';

const proptypes = exact({
  weekUserTimesheets: PropTypes.array,
});

/* eslint-disable max-len */
const OvertimeDetails = (props) => {
  const handleOpenTimesheet = (row) => {
    const { user, start_date: startDate } = row.original;
    const url = getUserTimesheetLink(user.id, moment(startDate.iso8601));
    openInNewTab(url);
  };

  const allWeeklyTimesheets = props.weekUserTimesheets;
  return (
    <div>
      <Panel className="panel-tabbed">
        <ReactTable
          data={allWeeklyTimesheets}
          filterable
          defaultFilterMethod={(filter, row) => { return defaultTableFiltering(filter, row); }}
          columns={[
            {
              Header: 'First Name',
              id: 'firstname',
              accessor: (e) => { return e.user.firstname; },
            },
            {
              Header: 'Last Name',
              id: 'lastname',
              accessor: (e) => { return e.user.lastname; },
            },
            {
              Header: 'District',
              id: 'districtName',
              accessor: (e) => { return e.user.default_district.name; },
            },
            {
              Header: 'Department',
              id: 'departmentName',
              accessor: (e) => { return e.user.default_department.name; },
            },
            {
              Header: 'Pay Type',
              id: 'payroll_type',
              accessor: (e) => { return e.user.payroll_type; },
            },
            {
              Header: 'Worked Hours',
              id: 'worked_hours',
              filterable: false,
              accessor: (e) => { return e.worked_hours.total_seconds; },
              Cell: (row) => {
                const cellObject = row.original.worked_hours;
                return (
                  <div className={severityOfHours(cellObject.hours)}>
                    <span>
                      {cellObject.to_string}
                    </span>
                  </div>
                );
              },
            },
            {
              Header: 'Out of Service',
              id: 'out_of_service',
              filterable: false,
              accessor: (e) => { return e.out_of_service.total_seconds; },
              minWidth: 100,
              Cell: (row) => {
                return (
                  <div>
                    {row.original.out_of_service.to_string}
                  </div>
                );
              },
            },
            {
              Header: 'Overtime',
              id: 'overtime',
              filterable: false,
              accessor: (e) => { return e.overtime.total_seconds; },
              minWidth: 75,
              Cell: (row) => {
                return (
                  <div>
                    {row.original.overtime.to_string}
                  </div>
                );
              },
            },
            {
              Header: 'PTO',
              id: 'pto',
              filterable: false,
              accessor: (e) => { return e.pto.total_seconds; },
              minWidth: 75,
              Cell: (row) => {
                return (
                  <div>
                    {row.original.pto.to_string}
                  </div>
                );
              },
            },
            {
              Header: 'Actions',
              id: 'actions',
              filterable: false,
              sortable: false,
              Cell: (row) => {
                return (
                  <div>
                    <Button
                      bsStyle="info"
                      onClick={() => { handleOpenTimesheet(row); }}
                    >View
                    </Button>
                  </div>

                );
              },
            },
          ]}
          defaultPageSize={10}
          className="-striped -highlight weeklyHourTable"
        />
      </Panel>
    </div>
  );
};

OvertimeDetails.propTypes = proptypes;
export default (OvertimeDetails);
